import React, { useState, useRef } from 'react';

const Futer = () =>  {

return (
    <div className='futer-block'>
        <h3>© 2020—2024 ichor.by</h3>
        <p><span>info@ichor.by</span>
        <span><a href="http://www.linkedin.com/in/дмитрий-шишкин-61a479130" target="_blank">linkedin</a></span></p>

    </div>
)
};

export default Futer;

